import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import PhoneImage from '../../../src/assets/images/notice/iconsphn.png';
import VideoCallImage from '../../assets/images/notice/icons3.png'
import { getIcon } from '../../utils/helperFunction';

const ReeceivedRequest = ({ details }) => {

    const iconList = {
        "voice": { img: PhoneImage, label: "Phone" },
        "video": { img: VideoCallImage, label: " Video Call" },
        "whatsapp": { img: VideoCallImage, label: " Whatsapp Call" },
    }

    return (
        <>
            <Box sx={{ background: '#fff', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px', padding: '25px', borderRadius: '16px', marginBottom: '25px' }}>
                <Typography variant='h2' sx={{ color: '#1E1E1E', fontSize: { xl: '24px !important', lg: '17px !important' }, marginBottom: '35px', fontWeight: 500 }}>
                    Request Received
                </Typography>
                {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>
                    <Typography sx={{ color: '#1E1E1E', fontSize: { xl: '18px !important', lg: '14px !important' }, fontWeight: 500 }}>
                        Request time
                    </Typography>
                    <Typography sx={{ color: '#5A5A5A', fontSize: { xl: '16px !important', lg: '12px !important' }, fontWeight: 400 }}>
                        Today at 9:30 PM
                    </Typography>
                </Box> */}
                {details?.schedule_calls?.length ? details?.schedule_calls?.map(item => {
                    return <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '30px' }}>
                        <Box sx={{ display: 'flex', gap: '15px' }}>
                            <Button
                                size="small"
                                variant="outlined" sx={{ border: 'none', textAlign: 'center', minWidth: 'auto', px: '0' }}
                                startIcon={getIcon(item?.callType)}
                            >
                            </Button>
                            <Typography sx={{ color: '#5A5A5A', fontSize: { xl: '18px !important', lg: '14px !important' }, fontWeight: 500 }}>
                                {iconList[item?.callType]?.label || "Call"}
                            </Typography>
                        </Box>

                        <Typography sx={{ color: '#5A5A5A', fontSize: { xl: '16px !important', lg: '12px !important' }, fontWeight: 400 }}>
                            {item?.date} · {item?.time}
                        </Typography>
                    </Box>
                }):<Box sx={{ textAlign:'center', marginBottom: '16px' }}>
                    <Typography sx={{ color: '#1E1E1E', fontSize: { xl: '18px !important', lg: '14px !important' }, fontWeight: 500 }}>
                        No upcoming requests
                    </Typography>
                </Box>}
            </Box>
        </>
    )
}

export default ReeceivedRequest